<div fxLayout="row" class="container" fxFlex="100" fxLayoutAlign="space-between" [formGroup]="formGroup">
  <!-- First column -->
  <div class="column" fxLayout="column" fxFlex="32">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'FirstName' | translate }}</mat-label>
      <input matInput type="text" formControlName="firstName" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'LastName' | translate }}</mat-label>
      <input matInput type="text" formControlName="lastName" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'Pesel' | translate }}</mat-label>
      <input matInput type="text" formControlName="pesel" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'EFoldersListFilters.DocumentId' | translate }}</mat-label>
      <input matInput type="text" formControlName="documentId" />
    </mat-form-field>
  </div>

  <!-- Second column -->
  <div class="column" fxLayout="column" fxFlex="32">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'Company' | translate }}</mat-label>
      <input
        matInput
        formControlName="company"
        placeholder="{{ 'Company' | translate }}"
        [matAutocomplete]="autocompleteEmployerObject"
        [errorStateMatcher]="matcher"
        />
        <mat-autocomplete #autocompleteEmployerObject="matAutocomplete" [displayWith]="displayValue">
          @for (company of companies$ | async; track company) {
            <mat-option [value]="company">
              {{ company.Name }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <div class="control">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'EFoldersListFilters.AddedDateFrom' | translate }}</mat-label>
          <input matInput [matDatepicker]="addedDateFromPicker" formControlName="addedDateFrom" autocomplete="date" />
          <mat-datepicker-toggle [for]="addedDateFromPicker" matSuffix></mat-datepicker-toggle>
          <mat-datepicker #addedDateFromPicker></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="control">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'EFoldersListFilters.ValidUntilDateFrom' | translate }}</mat-label>
          <input matInput [matDatepicker]="validUntilDateFromPicker" formControlName="validUntilDateFrom" autocomplete="date" />
          <mat-datepicker-toggle [for]="validUntilDateFromPicker" matSuffix></mat-datepicker-toggle>
          <mat-datepicker #validUntilDateFromPicker></mat-datepicker>
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'EFoldersListFilters.Document' | translate }}</mat-label>
        <input matInput type="text" formControlName="document" />
      </mat-form-field>
    </div>

    <!-- Third column -->
    <div class="column" fxLayout="column" fxFlex="32">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'EFoldersListFilters.Part' | translate }}</mat-label>
        <input matInput type="text" formControlName="part" />
      </mat-form-field>

      <div class="control">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'EFoldersListFilters.AddedDateTo' | translate }}</mat-label>
          <input matInput [matDatepicker]="addedDateToPicker" formControlName="addedDateTo" autocomplete="date" />
          <mat-datepicker-toggle [for]="addedDateToPicker" matSuffix></mat-datepicker-toggle>
          <mat-datepicker #addedDateToPicker></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="control">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'EFoldersListFilters.ValidUntilDateTo' | translate }}</mat-label>
          <input matInput [matDatepicker]="validUntilDateToPicker" formControlName="validUntilDateTo" autocomplete="date" />
          <mat-datepicker-toggle [for]="validUntilDateToPicker" matSuffix></mat-datepicker-toggle>
          <mat-datepicker #validUntilDateToPicker></mat-datepicker>
        </mat-form-field>
      </div>

      <div>
        <ng-content></ng-content>
      </div>
    </div>
  </div>
